import { sepolia as viemSepolia } from 'viem/chains'

import type { AppChain } from './chain.types'

export const sepolia = {
  ...viemSepolia,
  custom: {
    name: 'Ethereum Testnet Sepolia',
    shortName: 'Sepolia',
    morphoChainSlug: 'sepolia',
    blockExplorer: { baseUrl: 'https://sepolia.etherscan.io', name: 'Etherscan' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x8C5dDCD3F601c91D1BF51c8ec26066010ACAbA7c',
          startBlock: 6630358n
        },
        MorphoBlue: { address: '0xd011EE229E7459ba1ddd22631eF7bF528d424A14', startBlock: 6630358n },
        MetaMorphoV11Factory: {
          address: '0xa6c843fc53aAf6EF1d173C4710B26419667bF6CD',
          startBlock: 6637710n
        }
      }
    }
  }
} as const satisfies AppChain<{ v1: true; v2: false }>
